import { ICellRendererAngularComp } from '@ag-grid-community/angular'
import {
  ICellRendererFunc,
  ICellRendererParams,
  ValueFormatterFunc,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core'

@Component({
  selector: 'helios-custom-cell-renderer',
  template: `
    <span class="custom-group {{ levelClass }}">
      <button class="btn btn-sm row-btn" (click)="toggleExpansion()">
        <i class="mdi mdi-chevron-{{ expandedClass }}"></i>
      </button>
      <span #textOutput></span>
    </span>
  `,
  styles: [
    `
      .row-btn {
        padding: 0 4px;
      }
    `,
  ],
})
export class HeliosRowGroupRendererComponent
  implements ICellRendererAngularComp, AfterViewInit
{
  levelClass = ''
  expandedClass = ''
  text = ''
  params?: ICellRendererParams

  @ViewChild('textOutput', { static: true })
  textOutput?: ElementRef

  ngAfterViewInit(): void {
    if (this.textOutput) {
      this.textOutput.nativeElement.innerHTML = this.text
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return this.apply(params)
  }

  toggleExpansion() {
    if (!this.params) {
      return
    }

    const { node } = this.params
    node.setExpanded(!node.expanded)
  }

  agInit(params: ICellRendererParams): void {
    this.apply(params)
    this.watchOnExpansion()
  }

  watchOnExpansion() {
    if (!this.params) {
      return
    }

    const { node } = this.params
    node.addEventListener('expandedChanged', () => {
      this.setExpandedClass(node.expanded)
    })
  }

  apply(params: ICellRendererParams): boolean {
    this.params = params
    const {
      valueFormatted,
      data,
      api,
      node: { expanded, level, field },
    } = params

    let finalValue = ''

    if (!field) {
      finalValue = valueFormatted
    } else {
      const colDef = api.getColumnDef(field)

      if (colDef?.cellRenderer) {
        finalValue = (colDef.cellRenderer as ICellRendererFunc)(
          params,
        ) as string
      } else if (colDef?.valueFormatter) {
        finalValue = (colDef.valueFormatter as ValueFormatterFunc)(
          params as ValueFormatterParams,
        )
      } else {
        finalValue = valueFormatted
      }
    }

    this.text = finalValue

    if (Object.hasOwnProperty.call(data, 'childCount')) {
      const childCount = data.childCount
      this.text += ' (' + childCount + ')'
    }

    this.setExpandedClass(expanded)
    this.levelClass = `level-${level}`

    return true
  }

  setExpandedClass(expanded: boolean) {
    this.expandedClass = expanded ? 'down' : 'right'
  }
}
